'use client';

import { PageType, useEffectOnce } from '@libs/common-next';
import { useRef } from 'react';

type ClientStorageProps = {
    pageType?: PageType;
};

export default function ClientStorage({ pageType }: ClientStorageProps) {
    const effectRan = useRef(false);

    useEffectOnce(() => {
        if (!effectRan.current) {
            window.sessionStorage.previousPage = window.sessionStorage.currentPage ?? '';
            window.sessionStorage.currentPage = pageType;
        }

        // Delete pdpFindingMethod, but keep it in the PDP page so it
        // is used in analytics.
        if (!pageType || pageType !== PageType.PDP) {
            // We delete it so the value is always fresh.
            // There's pages that will overwrite it, but there's other that may not.
            // That's how we will account for "Others".
            delete window.sessionStorage.pdpFindingMethod;
        }

        return () => {
            effectRan.current = true;
        };
    });

    return '';
}
